import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

// -------------------- A P I  C A L L S --------------------

// Fetch all transport bail entries
export const fetchTransportBailData = createAsyncThunk(
  "transport/fetchTransportBailData",
  async () => {
    const response = await axios.get(`${baseUrl}?apicall=getTransportBailData`);
    return response.data;
  }
);

// Insert bail entry
export const InsertBailEntry = createAsyncThunk(
  "transport/InsertBailEntry",
  async (postData) => {
    const response = await axios.post(
      `${baseUrl}?apicall=insertBailEntry`,
      postData
    );
    return response.data;
  }
);



// update bail entry
export const updateTransportBailEntry = createAsyncThunk(
  "transport/updateTransportBailEntry",
  async (postData) => {
    const response = await axios.post(
      `${baseUrl}?apicall=updateTransportBailEntry`,
      postData
    );
    return response.data;
  }
);

export const deleteSingleTransportBail = createAsyncThunk(
  "deleteSingleTransportBail",
  async (id) => {
    const response = await axios.delete(
      `${baseUrl}?apicall=getTransportBailData&id=${id}`
    );
    return response.data;
  }
);

export const fetchSingleTransportBail = createAsyncThunk(
  "fetchSingleTransportBail",
  async (id) => {
    const response = await axios.get(
      `${baseUrl}?apicall=getSingleTransportBail&id=${id}`
    );
    return response.data;
  }
);

// SEND WHATSAPP MSG

export const sendTransportBailWhatsappMsg = createAsyncThunk(
  'sendTransportBailWhatsappMsg',
  async (id) => {
    console.log("id=>", id);
    const response = await axios.get(`${baseUrl}?apicall=sendTransportBailWhatsappMsg&id=${id}`);
    console.log("responsedaya", response.data);

    return response.data;
  }
);

// -------------------- S L I C E --------------------

const transportBailSlice = createSlice({
  name: "transportBail",
  initialState: {
    isLoading: false,
    bailData: null,
    insertResponse: null,
    singleBail: null,
    isError: false,
  },

  extraReducers: (builder) => {
    // Fetch Transport Bail Data
    builder.addCase(fetchTransportBailData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTransportBailData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.bailData = action.payload;
    });
    builder.addCase(fetchTransportBailData.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = action.error.message;
    });

    // Insert Bail Entry
    builder.addCase(InsertBailEntry.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(InsertBailEntry.fulfilled, (state, action) => {
      state.isLoading = false;
      state.insertResponse = action.payload;
    });
    builder.addCase(InsertBailEntry.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = action.error.message;
    });

    // Delete Transport Bail Entry
    builder.addCase(deleteSingleTransportBail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteSingleTransportBail.fulfilled, (state, action) => {
      state.isLoading = false;
      const deletedId = action.meta.arg;
      if (state.bailData?.data) {
        state.bailData.data = state.bailData.data.filter(
          (item) => item.ID !== deletedId
        );
      }
    });
    builder.addCase(deleteSingleTransportBail.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = action.error.message;
    });

    // Fetch Single Transport Bail
    builder.addCase(fetchSingleTransportBail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSingleTransportBail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.singleBail = action.payload;
    });
    builder.addCase(fetchSingleTransportBail.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = action.error.message;
    });

    // ---------------- SEND WHATSAPP MSG ----------------
    builder.addCase(sendTransportBailWhatsappMsg.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(
      sendTransportBailWhatsappMsg.fulfilled,
      (state, action) => {
        state.isLoading = false;

        const updatedId = action.meta.arg; // id passed in thunk

        if (state.bailData?.data) {
          state.bailData.data = state.bailData.data.map((item) =>
            item.ID === updatedId ? { ...item, w_msg_sts: "1" } : item
          );
        }
      }
    );

    builder.addCase(sendTransportBailWhatsappMsg.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = action.error.message;
    });
  },
});

export default transportBailSlice.reducer;
